module.exports = __webpack_public_path__ + "images/icons_v2/call-0e8d7ce5.svg";